/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

export const deeplinkRedirect = async ({ executeDeeplink, logger }) => {
  const result = await executeDeeplink()
  if (result) {
    logger.debug(`deeplink found and executed >>> deeplink target`)
    return result
  }
}
